// Resolves the realtime WebSocket endpoint by hostname, mirroring
// `getBackendUrl()` in @artic/api-client's custom-fetch so dev/staging/prod
// resolution stays consistent. The Phoenix realtime service serves the socket
// at `/socket` (dev: 127.0.0.1:4100 — see services/realtime).
const REALTIME_URLS = {
  production: 'wss://realtime.artic.works/socket',
  staging: 'wss://realtime.staging.artic.works/socket',
  development: 'ws://localhost:4100/socket',
} as const;

export function getRealtimeUrl(): string {
  const host = window.location.hostname;
  if (host.includes('staging')) return REALTIME_URLS.staging;
  if (host.includes('localhost')) return REALTIME_URLS.development;
  return REALTIME_URLS.production;
}
